const ABC_STATUS = {
    USER_CLOSE: "USER_CLOSE",
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    FAILURE: "FAILURE",
    ERROR: "ERROR"
};

const REDIRECT_STATUSES = [
    ABC_STATUS.USER_CLOSE,
    ABC_STATUS.SUCCESS,
    ABC_STATUS.PENDING,
    ABC_STATUS.FAILURE
];

export function ABCDOMContentLoaded(appId, reference_id) {
    const config = {
        applicationId: appId,
    };

    const cpgInstance = new window.abcsdk.Instance(config);

    const callback = (response) => {
        const status = response?.status;

        if (REDIRECT_STATUSES.includes(status)) {
            window.location.href = "/deposit-under-approval";
            return;
        }

        if (status === ABC_STATUS.ERROR) {
            showErrorModal("Failed!", "Something went wrong!",false);
            return;
        }
    };

    cpgInstance.deposit(callback, reference_id);
}

export function ABCCryptoDOMContentLoaded(appId, reference_id) {
    const config = {
        applicationId: appId,
    };

    const cpgInstance = new window.cpg.Instance(config);

    const callback = (response) => {
        const status = response?.status;

        if (REDIRECT_STATUSES.includes(status)) {
            window.location.href = "/deposit-under-approval";
            return;
        }

        if (status === ABC_STATUS.ERROR) {
            showErrorModal("Failed!", "Something went wrong!",false);
            return;
        }
    };

    cpgInstance.launch(callback, reference_id);
}

function showErrorModal(title, description) {
    const modal = document.getElementById("common-error-modal");

    if (!modal) return;
    modal.classList.remove("hidden");

    const titleElement = modal.querySelector("h2");
    if (titleElement) {
        titleElement.textContent = title;
    }

    const descElement = modal.querySelector("p");
    if (descElement) {
        descElement.textContent = description;
    }
}